import React from 'react';
import {
	Content,
	Label,
	TableCellChart,
	TableCellClassification,
	TableCellGroup,
	TableCellGroupDiv,
	TableCellMax,
	TableCellMin,
	TableRow,
	ToggleButton,
} from './CategoryHierarchy.styles';
import LinearGauge from '../LinearGuage/LinearGauge';
import { ApIcon } from '@alixpartners/ui-components';

const CategoryHierarchy = props => {
	const {
		data,
		onExpand,
		onToggle,
		showClassifications,
		showToggleButton,
	} = props;
	return (
		<>
			{data.map(items => {
				const {
					name,
					level,
					qmin: min,
					qmax: max,
					qmedian: median,
					clientSpend,
					children,
					isExpanded,
					group,
					aP_L1Category,
					aP_L2Category,
					aP_L3Category,
					aP_L4Category,
					id,
					peercount,
				} = items;
				const hasChildren = children?.length > 0;
				const icon = isExpanded
					? 'baseline_keyboard_arrow_down'
					: 'baseline_keyboard_arrow_right';
				return (
					<React.Fragment key={id ? id : name}>
						<TableRow group={group} level={level}>
							<TableCellGroup showClassifications={showClassifications}>
								<TableCellGroupDiv level={level}>
									{showToggleButton && (
										<ToggleButton
											onClick={
												hasChildren
													? () => onToggle(level, name, group, isExpanded)
													: () => onExpand(group, level, name, items)
											}
										>
											<ApIcon iconName={icon} iconColor="black" />
										</ToggleButton>
									)}
									<Label> {name} </Label>
								</TableCellGroupDiv>
							</TableCellGroup>
							{showClassifications && (
								<>
									<TableCellClassification>
										<Content>
											<Label> {aP_L1Category} </Label>
										</Content>
									</TableCellClassification>
									<TableCellClassification>
										<Content>
											<Label> {aP_L2Category} </Label>
										</Content>
									</TableCellClassification>
									<TableCellClassification>
										<Content>
											<Label> {aP_L3Category} </Label>
										</Content>
									</TableCellClassification>
									<TableCellClassification>
										<Content>
											<Label> {aP_L4Category} </Label>
										</Content>
									</TableCellClassification>
								</>
							)}
							<TableCellMin showClassifications={showClassifications}>
								<Content>
									<Label> {peercount} </Label>
								</Content>
							</TableCellMin>
							<TableCellMin showClassifications={showClassifications}>
								<Content>
									<Label> {min} </Label>
								</Content>
							</TableCellMin>
							<TableCellChart>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<LinearGauge
										values={{ group, level, min, max, median, clientSpend }}
									/>
								</div>
							</TableCellChart>
							<TableCellMax showClassifications={showClassifications}>
								<Content>
									<Label> {max} </Label>
								</Content>
							</TableCellMax>
						</TableRow>
						{isExpanded && (
							<>
								{hasChildren &&
									children.map(child => (
										<CategoryHierarchy
											key={Math.random()}
											data={[child]}
											onExpand={onExpand}
											onToggle={onToggle}
											showToggleButton={showToggleButton}
										/>
									))}
							</>
						)}
					</React.Fragment>
				);
			})}
		</>
	);
};

export default CategoryHierarchy;
